











import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    contentService,
} from "../services";

@Component
export default class SupportView extends Vue {
    body: null | string = null;

    async mounted() {
        this.body = await contentService.getContentString("mobisulo.support.body");
    }
}
